import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const FastForward = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="FastForward" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5459 21.3919C10.881 21.5625 11.2837 21.5299 11.5879 21.3088L22.5879 13.3088C22.8466 13.1207 22.9999 12.8201 23 12.5002C23 12.1804 22.8466 11.8798 22.5879 11.6917L11.5879 3.69166C11.2837 3.47055 10.881 3.43803 10.5459 3.60865C10.2108 3.77933 10 4.12422 10 4.50025V8.5442L2.58594 3.1897C2.2816 2.96993 1.8792 2.93884 1.54492 3.10962C1.21064 3.28058 1.00004 3.62479 1 4.00025V20.5002C1.00007 20.869 1.20324 21.2081 1.52832 21.3821C1.8534 21.5559 2.24793 21.5367 2.55469 21.3323L10 16.3684V20.5002C10.0001 20.8763 10.2108 21.2212 10.5459 21.3919ZM3 5.95533L10.4141 11.3108C10.7184 11.5305 11.1208 11.5616 11.4551 11.3909C11.7894 11.2199 11.9999 10.8757 12 10.5002V6.46314L20.2998 12.5002L12 18.5364V14.5002C12 14.1315 11.7968 13.7924 11.4717 13.6184C11.1466 13.4446 10.7521 13.4637 10.4453 13.6682L3 18.6311V5.95533Z" fill="#000" />
  </StyledIcon>
));

FastForward.displayName = 'FastForward';

export { FastForward };
